import { AxiosResponse } from 'axios';

const getFileName = (contentDisposition: string) => {
  const startIndex = contentDisposition.indexOf(`"`) + 1;
  const endIndex = contentDisposition.indexOf(`"`, startIndex);
  const fileName = contentDisposition.substring(startIndex, endIndex);

  //デコードするとスペースが"+"になるのでスペースへ置換します
  const decoded = decodeURI(fileName).replace(/\+/g, ' ');

  return decoded;
};

export const download = (res: AxiosResponse<any, any>) => {
  console.info('download response: ', res);

  const url = URL.createObjectURL(
    new Blob([res.data], { type: res.data.type }),
  );
  console.info('blob url: ', url);

  const contentDisposition = res.headers['content-disposition'];

  const fileName = getFileName(contentDisposition);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
  link.parentNode?.removeChild(link);
};
